/**
 * Inline failure message for an action the user just took. Renders nothing when there is no
 * message, so callers can drop it in unconditionally next to the control that failed —
 * which is the point: a rejected action that shows nothing reads as a broken app.
 *
 * The severity stripe carries the state in form as well as colour, so it survives both
 * grounds — the chalk one in room-web and the charcoal one in player-web.
 */
export function ErrorNotice({
  message,
  className = '',
}: {
  message: string | null;
  className?: string;
}) {
  if (!message) return null;

  return (
    <p
      role="alert"
      className={`border border-line border-l-4 border-l-bad bg-surface p-3 text-sm text-ink-900 ${className}`}
    >
      {message}
    </p>
  );
}
